module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip1-dd6195187d79e93a092ee1ba1810570c.png";